import PaymentHeader, { PaymentHeaderTypes } from "entities/payment-header";
import PaymentWarranty from "widgets/payment-warranty";
import { usePaymentContext } from "pages/payment/providers/PaymentProvider";
import { useOrderContext } from "app/providers/OrderProvider";
import { PaymentType } from "shared/utils/payment";
import PaymentMethods, { PaymentMethod } from "widgets/shared/payment-methods";
import PaymentClientService from "entities/payment-client-service";

interface PaymentTypeProps {
  paymentTypeList: PaymentType[];
}

const RemainingPayment = ({ paymentTypeList }: PaymentTypeProps) => {
  const { paymentAction, setPaymentAction, setBank, setPaymentMethod } =
    usePaymentContext();
  const { order } = useOrderContext();

  return (
    <div
      className={`gg-col-span-12 gg-mb-16 sm:gg-col-span-11 lg:gg-col-span-9 xl:gg-col-span-6 xl:gg-mb-0 xl:gg-pr-12`}
    >
      <PaymentHeader
        type={PaymentHeaderTypes.REMAINING_PAYMENT}
        className="gg-mb-10"
      />
      {!order?.warrantyPackage && <PaymentWarranty />}
      <PaymentMethods
        method={PaymentMethod.PARTIAL_PAYMENT}
        types={paymentTypeList}
        paymentAction={paymentAction}
        setPaymentAction={setPaymentAction}
      />
      <PaymentClientService />
    </div>
  );
};
export default RemainingPayment;
